var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketBw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_36369",
    "data-name": "Group 36369",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.375,
    height: 16,
    viewBox: "0 0 20.375 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5903",
    "data-name": "Rectangle 5903",
    width: 20.375,
    height: 16,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36368",
    "data-name": "Group 36368",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_510",
    "data-name": "Line 510",
    d: "M-9.657-7.126A.343.343,0,0,1-10-7.469V-9.657A.343.343,0,0,1-9.657-10a.343.343,0,0,1,.343.343v2.188A.343.343,0,0,1-9.657-7.126Z",
    transform: "translate(23.126 10)",
    fill: "#040504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_511",
    "data-name": "Line 511",
    d: "M-9.657-7.126A.343.343,0,0,1-10-7.469V-9.657A.343.343,0,0,1-9.657-10a.343.343,0,0,1,.343.343v2.188A.343.343,0,0,1-9.657-7.126Z",
    transform: "translate(23.126 23.126)",
    fill: "#040504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39776",
    "data-name": "Path 39776",
    d: "M17.844,16H2.531A2.534,2.534,0,0,1,0,13.469V10.188a.343.343,0,0,1,.343-.343,1.844,1.844,0,1,0,0-3.689A.343.343,0,0,1,0,5.812V2.531A2.534,2.534,0,0,1,2.531,0H17.844a2.534,2.534,0,0,1,2.531,2.531V5.812a.343.343,0,0,1-.343.343,1.844,1.844,0,1,0,0,3.689.343.343,0,0,1,.343.343v3.281A2.534,2.534,0,0,1,17.844,16ZM.687,10.508v2.961a1.846,1.846,0,0,0,1.844,1.844H17.844a1.846,1.846,0,0,0,1.844-1.844V10.508a2.531,2.531,0,0,1,0-5.015V2.531A1.846,1.846,0,0,0,17.844.687H2.531A1.846,1.846,0,0,0,.687,2.531V5.492a2.531,2.531,0,0,1,0,5.015Z",
    transform: "translate(0 0)",
    fill: "#040504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39777",
    "data-name": "Path 39777",
    d: "M254.721,277.243l-.135,1.517.135,1.517,1.314-.759,1.314-.758-1.179-.893Z",
    transform: "translate(-245.847 -267.726)",
    fill: "#080909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39778",
    "data-name": "Path 39778",
    d: "M331.261,233.052l-.135,1.517.135,1.517,1.314-.759,1.314-.758-1.179-.893Z",
    transform: "translate(-319.76 -225.052)",
    fill: "#080909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39779",
    "data-name": "Path 39779",
    d: "M331.261,147.7l-.135-1.517.135-1.517,1.314.759,1.314.758-1.179.893Z",
    transform: "translate(-319.76 -139.702)",
    fill: "#080909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39780",
    "data-name": "Path 39780",
    d: "M335.053,190.377l1.314-.758,1.314-.759v3.034l-1.314-.759Z",
    transform: "translate(-323.552 -182.377)",
    fill: "#080909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39781",
    "data-name": "Path 39781",
    d: "M254.721,103.511l-.135-1.517.135-1.517,1.314.759,1.314.758-1.179.893Z",
    transform: "translate(-245.847 -97.028)",
    fill: "#080909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39782",
    "data-name": "Path 39782",
    d: "M258.511,146.186l1.314-.758,1.314-.759V147.7l-1.314-.759Z",
    transform: "translate(-249.637 -139.703)",
    fill: "#080909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39783",
    "data-name": "Path 39783",
    d: "M181.969,104.272H184.6v-3.794l-1.314.759-1.314.758",
    transform: "translate(-175.722 -97.029)",
    fill: "#080909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39784",
    "data-name": "Path 39784",
    d: "M181.969,255.1H184.6v3.794l-1.314-.759-1.314-.758",
    transform: "translate(-175.722 -246.344)",
    fill: "#080909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39785",
    "data-name": "Path 39785",
    d: "M258.511,234.568l1.314.758,1.314.759v-3.034l-1.314.759Z",
    transform: "translate(-249.637 -225.051)",
    fill: "#080909",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketBw);
export default __webpack_public_path__ + "static/media/ticket-bw.ff1e945e71d7e6ee526710f9c7efcf61.svg";
export { ForwardRef as ReactComponent };